// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2alrj","content":"GlobalSearch_content__33sWH"};